<div class="chip-view">
  <div class="section">
    <h3>Базовый chip</h3>
    <div class="chips-container">
      <pa-chip label="Текст"></pa-chip>
      <pa-chip label="Ещё один"></pa-chip>
    </div>
  </div>

  <div class="section">
    <h3>Chip с иконкой</h3>
    <div class="chips-container">
      <pa-chip label="Основной" icon="pi pi-star"></pa-chip>
      <pa-chip label="Дом" icon="pi pi-home"></pa-chip>
      <pa-chip label="Пользователь" icon="pi pi-user"></pa-chip>
    </div>
  </div>

  <div class="section">
    <h3>Удаляемый chip</h3>
    <div class="chips-container">
      <pa-chip label="Удалить меня" [removable]="true"></pa-chip>
      <pa-chip
        label="С обработчиком"
        [removable]="true"
        (remove)="onChipRemove()"
      ></pa-chip>
    </div>
  </div>
</div>
